export default __webpack_public_path__ + "static/media/signals.94501304.png";